module.exports = {
          srcSet: __webpack_public_path__ + "87dca0162ad696089b3f6147d031bfb9-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "87dca0162ad696089b3f6147d031bfb9-1168.png",width: 1168,height: 234}],
          src: __webpack_public_path__ + "87dca0162ad696089b3f6147d031bfb9-1168.png",
          toString:function(){return __webpack_public_path__ + "87dca0162ad696089b3f6147d031bfb9-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AFUxbf1xT4X/bkWC/l8qdf5TEWv/WBJm/n1Bg/+EVGb+dC5z/3EQhvsAPhNZ+00eZv9SHWr+Vhpt/1kXbv9TAXD+eUNr/5OMfv51SWv/dw6H+Vu1KEeyDsm8AAAAAElFTkSuQmCC",
          width: 1168,
          height: 234
        }